import { TextFieldProps } from '@mui/material';
import React from 'react';

import { StyledTextField } from './styles';

export type ITextField = TextFieldProps & {
  maxWidth?: string;
};

export const TextField: React.FC<ITextField> = ({ variant = 'standard', maxWidth, ...props }) => {
  return <StyledTextField variant={variant} $maxWidth={maxWidth} {...props} />;
};

export default TextField;
